<template>
  <div class="banner-container">
    <el-carousel :height="carouselHeight" trigger="click" arrow="always" motion-blur :autoplay="false">
      <el-carousel-item v-for="(item, index) in bannerItems" :key="index">
        <div class="banner-item" :style="{ backgroundImage: `url(${item.image})` }">
          <div v-if="item.button" class="button-container">
            <el-button @click="item.button.action" type="primary">{{ item.button.text }}</el-button>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'BannerPage',
  setup() {
    const bannerItems = [
      {
        image: new URL('@/assets/secondbanner.png', import.meta.url).href,
        button: {
          text: 'booooooooooooooooook',
          action: () => {
            window.location.href = '/party';
          }
        }
      },
      { image: new URL('@/assets/firstPage.png', import.meta.url).href },
      { image: new URL('@/assets/thirdbanner.png', import.meta.url).href }
    ];
    
    const carouselHeight = ref('400px');
    
    const updateCarouselHeight = () => {
      const width = window.innerWidth;
      const height = width * 0.5625; // 16:9 aspect ratio
      carouselHeight.value = `${Math.min(height, 600)}px`; // Max height of 600px
    };
    
    onMounted(() => {
      updateCarouselHeight();
      window.addEventListener('resize', updateCarouselHeight);
    });
    
    onUnmounted(() => {
      window.removeEventListener('resize', updateCarouselHeight);
    });
    
    return {
      bannerItems,
      carouselHeight
    };
  }
};
</script>

<style scoped>
.banner-container {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  width: 100%;
  max-width: 1200px;
  margin: 100px auto 50px auto;
  padding: 5px;
}

.banner-item {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.button-container {
  border-radius: 10px;
  position: absolute;
  bottom: 40px;
  padding: 1px;
  justify-content: center;
}

.button-container .el-button {
  background-color: rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(255, 255, 255, 0) !important;
  color: rgba(255, 255, 255, 0) !important;
  border-radius: 20px;
  /* margin: 1px; */
  margin-right: 3px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container .el-button:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0) !important;
  color: rgba(255, 255, 255, 0) !important;
  border-radius: 20px;
  /* margin: 5px; */
  margin-right: 3px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-carousel__arrow {
  background-color: rgba(31, 45, 61, 0.5);
}

@media (max-width: 768px) {
  .banner-container {
    margin: 50px auto 30px auto;
    padding: 3px;
  }
  
  .button-container {
    bottom: 20px;
    padding: 0;
    display: flex;
    justify-content: center;
  }
  
  .button-container .el-button,
  .button-container .el-button:hover {
    font-size: 0.9rem;
    padding: 8px 15px;
    margin: 3px;
  }
  
  .el-carousel__arrow {
    width: 30px;
    height: 30px;
  }
  
  .el-carousel__arrow i {
    font-size: 12px;
  }
}
</style>